"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable max-lines-per-function */
const react_1 = require("react");
const react_textfit_1 = require("react-textfit");
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const i18n_1 = require("@completeanatomy/i18n");
const licenses_1 = require("@completeanatomy/licenses");
const access_1 = require("@completeanatomy/access");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const models_1 = require("@completeanatomy/models");
const odr_1 = require("@completeanatomy/odr");
function ModelsPanelButton(_a) {
    var { onClick, model, access, className } = _a, props = __rest(_a, ["onClick", "model", "access", "className"]);
    const { image, isDetailed, name, type, mask, isNew, isOnDemand } = model;
    const theme = (0, styled_components_1.useTheme)();
    const bgImg = getImage(image);
    const fixedBgImg = (0, ui_1.fixRelativeUrl)(bgImg);
    const licenses = (0, licenses_1.useUserLicenses)();
    const currentSelectedModel = (0, models_1.useSelectedModel)();
    const isOffline = (0, device_1.useIsDeviceOffline)();
    const isAccess = (0, access_1.useAccessCheck)(access);
    const [isFilled, setFilled] = (0, react_1.useState)(true);
    const [isOpenAccessModal, setIsOpenAccessModal] = (0, react_1.useState)(false);
    const isCached = (0, odr_1.useIsModelCached)(model.identifier);
    const hasAccessToAllModels = !!(licenses === null || licenses === void 0 ? void 0 : licenses.filter(license => license.isActive &&
        license.type !== bridge_schema_1.LicenseType.School &&
        license.type !== bridge_schema_1.LicenseType.Individual).length);
    const hasAccessToAllowedModels = !!(licenses === null || licenses === void 0 ? void 0 : licenses.filter(license => license.isActive &&
        (license.type === bridge_schema_1.LicenseType.School ||
            license.type === bridge_schema_1.LicenseType.Individual)).length);
    const isSelected = (currentSelectedModel === null || currentSelectedModel === void 0 ? void 0 : currentSelectedModel.index) === model.index;
    const hasAccess = access === bridge_schema_1.UIAccessModifier.Regular;
    const isAccessible = isCached || !(isOnDemand && isOffline);
    const withRibbon = !hasAccessToAllModels && hasAccessToAllowedModels && !hasAccess;
    let titleArray = name.trim().split(' ');
    let titleEnd = titleArray.splice(-1).join();
    let titleStart = titleArray.join(' ');
    const isOneLine = !/[-­ ]/.test(name);
    /**
     * Fix for Windows to close Models Panel after ripple animation
     */
    const clickWithDelay = (item) => {
        if (!isAccess || withRibbon) {
            setIsOpenAccessModal(true);
            return;
        }
        setTimeout(() => {
            onClick(Object.assign(Object.assign({}, item), { isAvailable: isCached }));
        });
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(access_1.AccessPopup, { isOpen: isOpenAccessModal, onClose: () => setIsOpenAccessModal(false), "data-e2e": 'ModelsPanelButton_AccessPopup' }), (0, jsx_runtime_1.jsxs)(Container, Object.assign({ className: className, "$bgImg": fixedBgImg, "$doubleHeight": mask === bridge_schema_1.BodyRegionMask.Default && !isDetailed, "$isFaded": !hasAccess || !isAccessible, "$isSelected": isSelected, "$isFilled": isFilled, onClick: () => {
                    clickWithDelay(model);
                } }, props, { "data-e2e": 'ModelsPanelButton_Container', children: [(0, jsx_runtime_1.jsx)(ModelTitle, { "aria-label": "Model Title", "$isFaded": !hasAccess || !isAccessible, "data-e2e": 'ModelsPanelButton_ModelTitle', children: isDetailed ? ((0, jsx_runtime_1.jsx)(react_textfit_1.Textfit, { mode: isOneLine ? 'single' : 'multi', max: 20, "data-e2e": 'ModelsPanelButton_Textfit', children: name })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [titleStart, " ", (0, jsx_runtime_1.jsx)(TitleEnd, { titleEnd: titleEnd, icon: type, "data-e2e": 'ModelsPanelButton_TitleEnd' })] })) }), (0, jsx_runtime_1.jsx)(ui_1.Ripple, { color: theme.ripple, duration: 700, onAnimationStart: () => setFilled(false), onAnimationEnd: () => setFilled(true), "data-e2e": 'ModelsPanelButton_Ripple' }), isNew && !withRibbon && ((0, jsx_runtime_1.jsx)(ui_1.Ribbon, { title: (0, i18n_1.Localized)(i18n_1.Strings.library.models.new), "data-e2e": 'ModelsPanelButton_Ribbon' })), withRibbon && (0, jsx_runtime_1.jsx)(ui_1.Ribbon, { title: (0, i18n_1.Localized)(i18n_1.Strings.common.premium), "data-e2e": 'ModelsPanelButton_Ribbon' })] }))] }));
}
exports.default = (0, ui_1.withA11y)(ModelsPanelButton);
const TitleEnd = (props) => {
    return ((0, jsx_runtime_1.jsxs)(NoWrap, { "data-e2e": 'NoWrap', children: [props.titleEnd, props.icon === bridge_schema_1.ModelType.Female || props.icon === bridge_schema_1.ModelType.Male ? ((0, jsx_runtime_1.jsx)(SexIcon, { name: props.icon === bridge_schema_1.ModelType.Female ? ui_1.Icons.Female_Sex : ui_1.Icons.Male_Sex, "data-e2e": 'SexIcon' })) : null] }));
};
const NoWrap = styled_components_1.default.span `
  display: inline-block;
`;
const Container = styled_components_1.default.button `
  position: relative;

  ${({ $doubleHeight }) => $doubleHeight && 'grid-row-end: span 2;'};

  width: 160px;
  height: ${({ $doubleHeight }) => ($doubleHeight ? '328px' : '160px')};

  ${ui_1.device.laptop((0, styled_components_1.css) `
    height: ${({ $doubleHeight }) => ($doubleHeight ? '336px' : '160px')};
  `)};

  background: ${({ theme, $isSelected, $isFilled }) => $isFilled && $isSelected
    ? theme.modelsPanel.selectedModel
    : theme.backgroundSecondary};
  background-image: url(${({ $bgImg }) => $bgImg});
  background-image: linear-gradient(
      to bottom,
      ${({ $isFaded, theme }) => $isFaded
    ? theme.modelsPanel.gradientFixDisabled
    : theme.modelsPanel.gradientFix}
        50%,
      ${({ theme }) => theme.backgroundSecondary}
    ),
    url(${({ $bgImg }) => $bgImg});
  background-repeat: no-repeat;
  background-position: top center;
  background-size: contain;
  border: none;
  border-radius: 8px;
  cursor: pointer;
`;
const SexIcon = (0, styled_components_1.default)(ui_1.Icon) `
  display: inline;
  width: 16px;
  height: 16px;

  padding-left: 4px;

  color: ${({ theme }) => theme.modelsPanel.title};
`;
const ModelTitle = styled_components_1.default.div `
  position: absolute;
  bottom: 8px;
  left: 8px;

  width: calc(100% - 16px);

  color: ${({ theme }) => theme.text};

  font-weight: 600;
  font-size: 20px;
  font-family: 'Main CA Font', sans-serif;
  text-align: left;
  word-break: break-word;

  opacity: ${({ $isFaded }) => ($isFaded ? 0.5 : 1)};
`;
function getImage(url) {
    try {
        const module = require(`../../assets/${url}.png`);
        return (0, ui_1.isString)(module) ? module : module.default;
    }
    catch (e) {
        return '';
    }
}
